/*
  Base file for stub.
  This is where all the actual stub code will go.
*/

const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { createPreventDefault } from '../../utilities/general';
import render from "../../utilities/render";
import { isNullOrUndefined, isUndefined } from "util";
import { isBlank } from "../../utilities/general";
import EditChecker from '../../components/EditChecker/EditChecker';
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
require("./newDiscount.less");

let els = {};
const elsModal = {};
const elsModalMap = {};
const elsMap = {
    discountsName: "#discounts-name",
    discountsMerchants:"#retailerList",
    discountsSaveBtn:".discounts-save-btn",
    discountsFormElement:"#discounts-create-edit",
    discountsValidateClass: ".discounts-validate",
    retailersdropdown:".retailer-list-select",
    merchantDiv:"#merchant-exists",
    discountsCancelBtn: "#discounts-cancel-btn",
    discountsNameExists:"#discounts-name-exists",
	  selectSwitch:"#select-switch",
	  selectMerchants: "#select-merchants",
	  selectTier: "#select-tier",
	  saveBtn :".save-btn"
	
}

function validateForm(formElement) {
  let validator, validationOpts;
  validationOpts = {
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  }
  validator = formElement.validate(validationOpts);
  validator.settings.ignore = ":disabled,:hidden";
  if (formElement.valid()) {
    return true;
  } else {
    return false;
  }
}

const defdiscountsName = "Default - All Merchants";
const defMerchant = "0";
const targetSelector = "#discounts-createedit";

run(targetSelector, (mainEl) => {
  let  discountCreateEditValuesdiv = mainEl.find("#discounts-create-edit-page-values-div");
  const portletNamespace = mainEl.data("portlet-namespace");
  const retailerCheckUrl = mainEl.data("retailer-code-check-url");
  const discountsNameCheckUrl = mainEl.data("discounts-name-check-url");
  const defaultdiscounts = mainEl.data("defaultdiscounts");
  const rtdDefault= mainEl.data("rtd-default");
  const discounts= JSON.stringify(mainEl.data("discounts"));
  const savediscountsUrl = mainEl.data("discount-save-url");
  const viewDiscountDetailURL =mainEl.data("view-discount-detail-url");
  const flow = mainEl.data("edit-form");
  function init() {
    generateModals();
    setElementsInModals();
    setElements();
    loadDataOnUI();
    bindElements();
    switchMerchants();
    setupEditChecker();
    setInitialState();

  }

  function setInitialState() {
    els.discountsFormElement.validate(customValidateProps);  
}

	
	function setupEditChecker(){
        EditChecker.bindNavigation();
        EditChecker.bindChangeListener(els.discountsFormElement);
        EditChecker.bindCancelButton(els.discountsCancelBtn);
      
      }
	  
	  function loadDataOnUI(){
        let serviceValues = [];
        let divid;

        getDiscountValuesSectionHtml();    
        

        $("div[id^='US-']").each(function(){
            divid= "#"+this.id;
                   
        });

        $("div[id^='CA-']").each(function(){
            //divid = "#" + this.id;     
        });

        $("div[id^='OTH-']").each(function(){
           // divid = "#" + this.id;      
        });
      }

	function setElementsInModals() {
        const body = $('body');
        setElementsFromScope(elsModal, elsModalMap, body);
    }
  
   let counter = 0;
	 function getDiscountValuesSectionHtml(){
    discountCreateEditValuesdiv.append(valuesHtml);
    let usSurchargesObj = JSON.parse(discounts).discounts.usSurchargesMap;
    let caSurchargesObj = JSON.parse(discounts).discounts.caSurcharges;
    let otherSurchargesObj = JSON.parse(discounts).discounts.otherSurcharges; 
    shippingMethodRendering(usSurchargesObj,'#usShippingMethodCId','fedEx-smart-post-expand','toggler-target-united-states','US');
    shippingMethodRendering(caSurchargesObj,'#caShippingMethodCId','fedex-international-economy-expand','toggler-target-canada','CA');
    shippingMethodRendering(otherSurchargesObj,'#otherShippingMethodId','fedex-international-economy-outside-expand','toggler-target-outside','CA');
  }

  function shippingMethodRendering(surchargeobj,idVal,expandval,togglerVal,countryCode){
    for (let i=0; i < Object.keys(surchargeobj).length;i++ ) { 
      const valuesContentHtml =   require("./html/discountCreateEditContentDisplay.html");
      const shippingMethods = $(render(valuesContentHtml, {
        usSurchargesValue : Object.keys(surchargeobj)[i],
        expandableTarget: expandval,
        btnExpandableTarget: togglerVal,
        code: countryCode,
        counter
      }));
      $(idVal).append(shippingMethods);
      surchargesRendering(i,surchargeobj)
    }
  }

  function surchargesRendering(i,surchargeobj){
    for (let j=0; j < Object.values(surchargeobj)[i].length;j++ ) {
      const surchargeHtml =   require("./html/surchargesValues.html");
      const surcharges = $(render(surchargeHtml, {
        surchargeLabel : Object.values(surchargeobj)[i][j].dmdMeaning,
        surchargeValue : Object.values(surchargeobj)[i][j].rddShipmentMethodId,
        j,	
        surchargeDiscountValue : Object.values(surchargeobj)[i][j].rddDiscountValues
      }));
      $('#discount-values-'+counter).append(surcharges);
    }
    counter = counter + 1;
  }

const discountCreateEditContentDisplay = function(discountCreateEditValues, expandableTarget,btnExpandableTarget,countryCode) {
  const init = render(
    require("./html/discountCreateEditContentDisplay.html"),
    {
      discountCreateEditValues: discountCreateEditValues,
      expandableTarget: expandableTarget,
      btnExpandableTarget:btnExpandableTarget,
	    code: countryCode
    }
  )
  return init;
};


 const valuesHtml  = function(){
  const valuesContent = render(
    require("./html/discountCreateEditValues.html"),{  
      discountName:JSON.parse(discounts).discounts.rtdName
      
    })
	return valuesContent;
 };

  
  let SaveModal;
   function setElements(){
    setElementsFromScope(els, elsMap, mainEl);
  }
  
  function bindElements(){
    
    let existingDiscountsName=$('#discounts-name').val();
    els.retailersdropdown.on('blur', validateRetailer); 
    $('#discounts-name').on('blur', function(e){
      if($(this).val()!=existingDiscountsName){
        validateDiscountsName();
      }    
      else{
        $('#discounts-name-exists').hide();
      }        
      }); 
      
      $('.discounts-validate').on('change', checkdiscountsValidation);
        
		 $('body').on('click', '.discount-section-collapse-expand-btn', function (e) {
            let target = this.getAttribute('data-q-expander-target');
            $('div' + target).find('i.fa-angle-up').click();
            if ($(this).hasClass('active')) {
            $('div' + target).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
            } else {
            $('div' + target).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
            }

            $(this).toggleClass("active");

        }); 

        if(rtdDefault === "Y" && flow != "duplicate"){
          $("#discounts-name").val("Default - All Merchants")
          $("#discounts-name").attr("disabled","true")
        }
        els.saveBtn.click(createPreventDefault(savediscounts));

		
	 $('#switch-merchants').on('click', switchMerchants);
  }

  function generateModals(){
    SaveModal = new SubmitModalFlow({
      confirmModalTitle: 'Submit Discount Information',
      modalDialogClass: "q-modal-dialog-500",
      confirmModalBody: `<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants.</div>`,
      confirmModalBtnText: 'Submit',

      onConfirmClick: function () {
        SaveModal.showLoadingModal();
        setTimeout(function () {
          SaveModal.showSuccessModal();
        }, 3000);
        setTimeout(function () {
          SaveModal.hideAllModals();
        }, 6000);
      }
    });
    SaveModal.init();
  }

  function initConfigPanel(){
    // Instantiate config panel here. Component has already been imported at the top.
  }

  function showSaveModal() {
    SaveModal.showConfirmModal();
  }

  function checkdiscountsValidation(e) {
        e.preventDefault();
        let discountsInputEle = $(this);
        let closetErrorEle = discountsInputEle.parent().find('label');
        let closetRequiredErrorElw = discountsInputEle.hasClass('error');
        validateInput(closetErrorEle, discountsInputEle.val());

    }

    function validateInput(closetErrorEle, inputValue) {
        let pattern = /^[0-9]+$/;
        if (inputValue == '') {
            closetErrorEle.hide();
        } else if (!inputValue.match(pattern)) {
            closetErrorEle.show();
        } else if (inputValue < 0 || inputValue > 100) {
            closetErrorEle.show();
        } else {
            closetErrorEle.hide();
        }
    }

   

    


  function savediscounts() {
    const isValid = validateForm(els.discountsFormElement);
    let submitdiscountsUrl = savediscountsUrl+'&flow='+flow;
    if (isValid && !els.discountsFormElement.find('.q-sim-error').is(':visible')) {
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Submit Discounts ",
        confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants. </div>',
        confirmModalBtnText: "Submit",
        onConfirmClick: function () {
          submitModalFlow.showLoadingModal();
          $.ajax({
            data: els.discountsFormElement.serialize(),
            url: submitdiscountsUrl,
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
              EditChecker.setPageClean();
              submitModalFlow.hideAllModals();
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                const discountDetailUrlFullURL = `${viewDiscountDetailURL}&discId=${data.data}`;
                window.location.href = discountDetailUrlFullURL;
                 }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

            },
            error: function (data) {
              submitModalFlow.hideAllModals();
              submitModalFlow.showFailureModal();
            }
          });
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  };

    function validateRetailer() {
        const selectedRetailerId= els.retailersdropdown.val(); 
        let data = 	{ 
	[`${portletNamespace}selectedRetailerId`]: JSON.stringify(selectedRetailerId)
            };
        
        if(!isNullOrUndefined(selectedRetailerId) && !isBlank(selectedRetailerId)){
            $.ajax({
            url: retailerCheckUrl,
            dataType:"JSON",
            type: 'POST',
            data: data,         
            success: function(data){
               if(data.response== true) {
                   $(els.merchantDiv.show());
                   els.discountsFormElement.find('.merchant-names').empty();
                   els.discountsFormElement.find('.merchant-names').append(data.merchantList);
                  
               }else{
                    $(els.merchantDiv.hide());
                 
               }  
            }  
         });
        }     
      }
	  
	  function switchMerchants() {
        const selectSwitch= $('#select-switch')[0].checked; 
        if(selectSwitch){
			$('#select-merchants').show();
			$('#select-tier').hide();
			
		}else{
			$('#select-merchants').hide();
			$('#select-tier').show();
		}
           
      }

      function validateDiscountsName() {
        const discountsNameVal = $('#discounts-name').val();   
        let data = 	{ 
          [`${portletNamespace}discountsName`]: discountsNameVal
            };
        
        if (!isNullOrUndefined(discountsNameVal) && !isBlank(discountsNameVal)){
            $.ajax({
            url: discountsNameCheckUrl,
            dataType:"JSON",
            type: 'POST',
            data: data,         
            success: function(data){
               if(data.response== true) {
                   $('#discounts-name-exists').show();                 
                   return false;
               }else{
                $('#discounts-name-exists').hide();
                    return true;
               }  
            }  
         });
        }     
      }
 
    
  init();
});


// WEBPACK FOOTER //
// ./src/pages/discounts/createEditdiscounts.js